import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import Link from 'gatsby-link'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import React from 'react'
import logo from '../components/images/logo-autoclub.png'
import Helmet from 'react-helmet'
import favicon from '../components/images/favicon.png'

const styles = theme => ({
  container: {
    width: '70%',
    [theme.breakpoints.down('lg')]: {
      width: '75%',
    },
    [theme.breakpoints.down('md')]: {
      width: '88%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '95%',
    },
    margin: '0 auto',
    padding: '40px 0',
  },
  coloredBandana: {
    backgroundColor: theme.palette.primary.main,
    height: 20,
  },
  colorDark: {
    color: theme.palette.primary.main,
  },
  textFieldShort: {
    width: '47%',
  },
})

class WhoWeAre extends React.Component {
  render() {
    const posts = get(this, 'props.data.allMarkdownRemark.edges')
    const { classes } = this.props

    return (
      <div className={classes.container}>
        <Helmet>
          <title>Who we are</title>
          <link rel="icon" type="favicon" href={favicon} sizes="16x16" />
        </Helmet>
        <div className={classes.coloredBandana} />
        <Paper style={{ marginBottom: 55, padding: '20px 30px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Link to={'/'}>
              <img src={logo} width={64} height={37} />
            </Link>
            <h3 className={classes.colorDark} style={{ marginLeft: 20 }}>
              AUTO CLUB REVIEWS - WHO WE ARE
            </h3>
          </div>
          <p className={classes.colorDark}>
            Auto Club Reviews is an experienced team that has worked with the
            very best independent car service companies, dedicated to delivering
            the best possible tools, accesories and automotive advice, all
            around the world.
          </p>
          <p className={classes.colorDark}>
            We look forward to advising you to make your entire automobile
            experience an exceptional one.
          </p>
        </Paper>
      </div>
    )
  }
}

WhoWeAre.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(WhoWeAre)



// WEBPACK FOOTER //
// ./src/pages/who-we-are.js